export const serviceCityPages = {
  "cctv-installation": {
    delhi: {
      slug: "cctv-installation/delhi",
      city: "Delhi",
      title: "CCTV Installation in Delhi | Suraksha 24X7",
      h1: "CCTV Camera Installation in Delhi",
      description:
        "Professional CCTV installation services in Delhi for homes, offices, shops, warehouses, society gates and commercial properties.",
      intro:
        "Suraksha 24X7 installs reliable CCTV systems that improve visibility, deter theft, and keep your property monitored around the clock.",
      highlights: [
        "IP and HD CCTV camera setup",
        "Night vision and remote mobile viewing",
        "Dedicated cabling and NVR/DVR configuration",
        "AMC support and maintenance plans",
      ],
      benefits: [
        "24/7 surveillance for homes and businesses",
        "Remote monitoring through mobile apps",
        "Clear evidence capture for disputes and security incidents",
        "Scalable layouts for small and large spaces",
      ],
      faqs: [
        {
          q: "How much does CCTV installation cost in Delhi?",
          a: "The cost depends on camera count, resolution, storage, cabling, and location. We provide site-based quotations after an assessment.",
        },
        {
          q: "Do you offer CCTV for commercial spaces?",
          a: "Yes. We design and install CCTV solutions for offices, factories, warehouses, retail stores and residential societies.",
        },
      ],
    },
    gurugram: {
      slug: "cctv-installation/gurugram",
      city: "Gurugram",
      title: "CCTV Installation in Gurugram | Suraksha 24X7",
      h1: "CCTV Camera Installation in Gurugram",
      description:
        "CCTV installation in Gurugram for residential communities, offices, warehouses, IT parks and retail properties.",
      intro:
        "We help property owners in Gurugram secure entrances, perimeters, interiors and parking areas with durable surveillance systems.",
      highlights: [
        "Enterprise-grade surveillance systems",
        "Indoor and outdoor CCTV coverage",
        "Access to recorded footage from mobile devices",
        "Structured cabling and smart monitoring setup",
      ],
      benefits: [
        "Reduce theft, vandalism and unauthorised entry",
        "Protect your gated community or commercial site",
        "Monitor staff and visitor movement in real time",
        "Maintain compliance and records for audits",
      ],
      faqs: [
        {
          q: "Is CCTV installation suitable for offices and warehouses?",
          a: "Yes. We tailor camera placement and system design based on entry points, storage areas, parking zones and compliance needs.",
        },
        {
          q: "Can I access CCTV footage remotely?",
          a: "Yes. We configure the system for remote mobile and laptop access through secure credentials.",
        },
      ],
    },
    noida: {
      slug: "cctv-installation/noida",
      city: "Noida",
      title: "CCTV Installation in Noida | Suraksha 24X7",
      h1: "CCTV Installation Services in Noida",
      description:
        "Trusted CCTV installation in Noida for homes, societies, offices and commercial spaces with monitoring and support.",
      intro:
        "Our Noida installation teams design and deploy CCTV systems that fit the layout, security risk and daily operational needs of each site.",
      highlights: [
        "Site survey and camera planning",
        "Dome, bullet and PTZ camera deployment",
        "NVR/DVR integration and remote access",
        "Support after installation and annual AMC",
      ],
      benefits: [
        "Improve property visibility and deterrence",
        "Track movement from mobile or desktop",
        "Support safer operations and incident investigation",
        "Designed for residential and commercial settings",
      ],
      faqs: [
        {
          q: "Do you install CCTV for residential societies?",
          a: "Yes. We install CCTV for entry gates, parking zones, lobbies, boundaries and common area monitoring.",
        },
      ],
    },
    ghaziabad: {
      slug: "cctv-installation/ghaziabad",
      city: "Ghaziabad",
      title: "CCTV Installation in Ghaziabad | Suraksha 24X7",
      h1: "CCTV Camera Installation in Ghaziabad",
      description:
        "Suraksha 24X7 delivers CCTV installation across Ghaziabad for residential, commercial and industrial properties.",
      intro:
        "Whether you need a basic home setup or a complete business surveillance network, we design the right CCTV solution for your site.",
      highlights: [
        "Boundary and perimeter monitoring",
        "Commercial surveillance system design",
        "Camera configuration with recording and storage",
        "On-site maintenance and upgrades",
      ],
      benefits: [
        "Protection for homes, shops and large sites",
        "Reduced security response times",
        "Reliable recorded footage and alerts",
        "Simple operation for users and administrators",
      ],
      faqs: [
        {
          q: "Do you offer CCTV maintenance after installation?",
          a: "Yes. We offer AMC, troubleshooting, fault resolution, and system enhancement support for installed equipment.",
        },
      ],
    },
    faridabad: {
      slug: "cctv-installation/faridabad",
      city: "Faridabad",
      title: "CCTV Installation in Faridabad | Suraksha 24X7",
      h1: "CCTV Camera Installation in Faridabad",
      description:
        "Smart security systems and CCTV installations in Faridabad for homes, offices, malls, factories and residential communities.",
      intro:
        "Faridabad clients rely on Suraksha 24X7 for system design, installation and after-sales support for secure property monitoring.",
      highlights: [
        "Custom surveillance planning",
        "HD camera installation and monitoring",
        "Smart storage and retrieval options",
        "Guidance for product selection and placement",
      ],
      benefits: [
        "Round-the-clock site visibility",
        "Improved ownership and staff confidence",
        "Document incidents effectively",
        "Professional installation with local support",
      ],
      faqs: [
        {
          q: "Can you install CCTV for small offices as well as large facilities?",
          a: "Yes. We scale systems to suit the size, security risks and operational needs of each property.",
        },
      ],
    },
  },
  "access-control": {
    delhi: {
      slug: "access-control/delhi",
      city: "Delhi",
      title: "Access Control Systems in Delhi | Suraksha 24X7",
      h1: "Access Control Solutions in Delhi",
      description:
        "Biometric and RFID access control installation in Delhi for offices, factories, residential societies and commercial premises.",
      intro:
        "Our access control systems help businesses manage entry, improve accountability, and restrict unauthorised access to sensitive areas.",
      highlights: [
        "Biometric fingerprint and face access",
        "Door controllers and RFID systems",
        "Visitor management and attendance",
        "Integration with CCTV and alarms",
      ],
      benefits: [
        "Stronger control over who enters your premises",
        "Track attendance and staff movement",
        "Improve safety and accountability",
        "Protect sensitive business zones",
      ],
      faqs: [
        {
          q: "What is the best access control system for offices?",
          a: "For office setups, biometric and RFID systems are commonly recommended for secure and efficient entry management.",
        },
      ],
    },
    gurugram: {
      slug: "access-control/gurugram",
      city: "Gurugram",
      title: "Access Control System Gurugram | Suraksha 24X7",
      h1: "Access Control System Installation in Gurugram",
      description:
        "Modern access control systems in Gurugram for gated communities, office campuses, business parks and industrial facilities.",
      intro:
        "We help businesses and residential communities manage access securely with smart door entry systems, biometric readers and centralised control.",
      highlights: [
        "Visitor entry management",
        "Biometric and card-based access",
        "Door access integration with CCTV",
        "Customised permissions and audit trail",
      ],
      benefits: [
        "Prevent unauthorised entry",
        "Track employee movement and attendance",
        "Improve operational transparency",
        "Support integrated security ecosystems",
      ],
      faqs: [
        {
          q: "Can access control be integrated with CCTV?",
          a: "Yes. Access control, CCTV, and alarm systems can work together for complete site monitoring and incident verification.",
        },
      ],
    },
  },
  "biometric-attendance": {
    delhi: {
      slug: "biometric-attendance/delhi",
      city: "Delhi",
      title: "Biometric Attendance System in Delhi | Suraksha 24X7",
      h1: "Biometric Attendance Solutions in Delhi",
      description:
        "Biometric attendance and access control installation in Delhi for offices, schools, factories and multi-site operations.",
      intro:
        "Suraksha 24X7 installs attendance systems that improve punctuality, reduce manual errors and provide a dependable workforce record.",
      highlights: [
        "Fingerprint and face attendance devices",
        "Role-based access permissions",
        "Attendance reports and payroll-ready data",
        "Linked support and system maintenance",
      ],
      benefits: [
        "Ensure accurate attendance tracking",
        "Minimise fake or duplicate attendance records",
        "Support HR and payroll workflows",
        "Strengthen office security and monitoring",
      ],
      faqs: [
        {
          q: "Who should use a biometric attendance system?",
          a: "Schools, offices, warehouses, factories and service businesses use biometric attendance to improve staff tracking and control.",
        },
      ],
    },
  },
  "boom-barrier": {
    gurugram: {
      slug: "boom-barrier/gurugram",
      city: "Gurugram",
      title: "Boom Barrier Installation in Gurugram | Suraksha 24X7",
      h1: "Boom Barrier Installation in Gurugram",
      description:
        "Boom barrier and entry management solutions in Gurugram for commercial parks, society gates, industrial sites and office compounds.",
      intro:
        "Our boom barrier systems help control traffic flow, prevent unauthorised entry and improve the security of gated premises.",
      highlights: [
        "Automatic entry and exit control",
        "Vehicle access for residential and commercial gates",
        "Integration with RFID, CCTV and intercom systems",
        "Robust construction for high-traffic areas",
      ],
      benefits: [
        "Improve vehicle flow and gate control",
        "Reduce security lapses at entry points",
        "Minimise congestion and unauthorised access",
        "Suitable for gated communities and office campuses",
      ],
      faqs: [
        {
          q: "Is boom barrier installation suitable for residential societies?",
          a: "Yes. Boom barriers are a common solution for gated communities, office campuses and commercial facilities requiring controlled vehicle access.",
        },
      ],
    },
  },
};

export const DELHI_NCR_CITIES = [
  "delhi",
  "new-delhi",
  "gurugram",
  "gurgaon",
  "noida",
  "greater-noida",
  "ghaziabad",
  "faridabad",
  "dwarka",
  "janakpuri",
  "rohini",
  "saket",
  "pitampura",
  "kapashera",
  "vasant-kunj",
  "narela",
  "laxmi-nagar",
  "patparganj",
  "mayur-vihar",
  "rajouri-garden",
  "karol-bagh",
  "chanakya-place",
  "uttam-nagar",
];

export const caseStudyPages = {
  "warehouse-cctv-gurugram": {
    slug: "warehouse-cctv-gurugram",
    title: "Warehouse CCTV Installation in Gurugram",
    city: "Gurugram",
    industry: "Warehouse & Logistics",
    summary:
      "A logistics facility needed stronger perimeter coverage, better monitoring of loading bays and secure evidence recording for all vehicle movement.",
    challenge:
      "The warehouse had blind spots around the loading area and a limited view of entry and exit points. Security incidents and inventory risks required stronger visibility and faster incident review.",
    solution:
      "We designed a CCTV network with high-rise outdoor cameras, coverage across loading docks and entry gates, and a central monitoring setup for local and remote visibility.",
    result:
      "The client gained full visibility across critical movement zones, reduced real-time security risk, and improved operational oversight for staff and vehicles.",
    deliverables: [
      "Outdoor CCTV coverage for exits and parking",
      "Loading bay and gate monitoring",
      "Remote access and recording setup",
      "System support and staff training",
    ],
    cta: "Need a similar warehouse surveillance solution?",
  },
  "society-cctv-dwarka": {
    slug: "society-cctv-dwarka",
    title: "Residential Society CCTV Installation in Dwarka",
    city: "Dwarka",
    industry: "Residential Society",
    summary:
      "A residential community wanted a safer environment for residents, controlled access and visible monitoring of gates and common facilities.",
    challenge:
      "The gate area had weak visibility, late-night access concerns and limited incident proof during disputes or security issues.",
    solution:
      "Suraksha 24X7 deployed a monitored CCTV solution covering the main gate, internal common areas and parking zones, supported by on-site control and reporting.",
    result:
      "Residents benefited from improved monitoring, better gate security and stronger confidence in day-to-day safety operations.",
    deliverables: [
      "Entry gate camera coverage",
      "Parking and lobby visibility",
      "Remote viewing for committee members",
      "Improved resident safety monitoring",
    ],
    cta: "Looking for a safer society entry system?",
  },
  "corporate-access-control-delhi": {
    slug: "corporate-access-control-delhi",
    title: "Corporate Access Control Installation in Delhi",
    city: "Delhi",
    industry: "Corporate Office",
    summary:
      "A growing office campus needed strict entry control and a consistent record of staff movement across multiple access points.",
    challenge:
      "The office had multiple entry points and required stronger accountability without slowing staff movement or increasing manual supervision.",
    solution:
      "We installed biometric and RFID-based access control with a central management setup and integration with the site’s security system.",
    result:
      "The client improved staff accountability, monitored movement more effectively and limited unauthorised access to office zones.",
    deliverables: [
      "Biometric and card-based access",
      "Door-level access permissions",
      "Security data and audit logs",
      "Integration with CCTV and visitor tracking",
    ],
    cta: "Need stricter office access control?",
  },
};
